import type { DocumentTemplateVersionDetailPayload } from '@Application/Documents/Templates/Actions/documentTemplateVersionFetched';

// The `201` response is the created version, with its declaration — never the template itself.
// `payload.template.id` is how a caller learns the new template's identifier.
export type DocumentTemplateCreatedPayload = DocumentTemplateVersionDetailPayload;

export type DocumentTemplateCreatedAction = {
	type: 'DOCUMENT_TEMPLATE_CREATED';
	payload: DocumentTemplateCreatedPayload;
};

export default (payload: DocumentTemplateCreatedPayload): DocumentTemplateCreatedAction => ({
	type: 'DOCUMENT_TEMPLATE_CREATED',
	payload,
});
